import axios from "axios";

const endpoint_url = "/message/whatsappMessageTemplate/delete";

const deleteWhatsappMessageTemplate = ({whatsapp_message_template_uuid}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, {
        whatsapp_message_template_uuid: whatsapp_message_template_uuid
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default deleteWhatsappMessageTemplate;
